
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import { getSelectedProductIdd, setSelectedProductIdd } from './globalState';





const styles = {
  container: {
    padding: '20px',
    fontFamily: '"Lora", serif',
    backgroundColor: '#FDF6E8',
    position: 'relative',
  },
  storeName: {
    backgroundColor: '#3C2F2F',
    color: '#F4C430',
    fontSize: '48px',
    fontWeight: 'bold',
    padding: '25px 50px',
    textAlign: 'center',
    letterSpacing: '4px',
    textTransform: 'uppercase',
    borderBottom: 'none',
    marginBottom: '0',
    fontFamily: '"Playfair Display", serif',
  },
  storeTitle: {
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    fontSize: '24px',
    fontWeight: 'normal',
    padding: '10px 20px',
    textAlign: 'center',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginTop: '0',
    fontFamily: '"Lora", serif',
  },
 controls: {
      marginTop: '20px',
      display: 'flex', // Use Flexbox
      justifyContent: 'space-between', // Space between left and right groups
      alignItems: 'center', // Vertically align items
    },
    leftGroup: {
      display: 'flex', // Group left buttons
      gap: '10px', // Space between left buttons
    },
    rightGroup: {
      display: 'flex', // Group right buttons
      gap: '10px', // Space between right buttons
    },



  searchInput: {
    width: '100%',
    maxWidth: '400px',
    minWidth: '200px',
    padding: '12px 18px',
    fontSize: '16px',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    backgroundColor: '#FFF',
    boxSizing: 'border-box',
    outline: 'none',
    color: '#3C2F2F',
    transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
    boxShadow: '0 0 6px rgba(212, 163, 115, 0.2)',
    fontFamily: '"Lora", serif',
  },
  browseButton: {
    padding: '12px 24px',
    backgroundColor: '#D4A373',
    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  menuContainer: {
    position: 'absolute',
    top: '180px',
    left: '20px',
    zIndex: 1000,
    display: 'flex',
  },
  setMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
  },
  categoryMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
    position: 'relative',
    padding: '10px',
  },
  subcategoryMenu: {
    backgroundColor: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    minWidth: '200px',
    padding: '15px',
  },
  menuItem: {
    padding: '10px 15px',
    fontSize: '1rem',
    color: '#3C2F2F',
    cursor: 'pointer',
    fontFamily: '"Lora", serif',
    transition: 'background-color 0.3s ease',
  },
  productList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '25px',
    marginTop: '30px',
  },
  productCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px',
    border: '1px solid #E8D5B9',
    borderRadius: '10px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
  },
  productImageWrapper: {
    flex: '0 0 160px',
    marginBottom: '15px',
    textAlign: 'center',
    borderRadius: '8px',
    position: 'relative',
    zIndex: 1,
  },
  productDetailsWrapper: {
    flex: '1',
    padding: '0 10px',
    textAlign: 'center',
  },
  productName: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#3C2F2F',
    fontFamily: '"Playfair Display", serif',
    marginBottom: '10px',
    textTransform: 'capitalize',
  },
  productDescription: {
    fontSize: '1rem',
    color: '#6B4E31',
    fontFamily: '"Lora", serif',
    marginBottom: '10px',
    lineHeight: '1.6',
  },
  productStock: {
    fontSize: '1.1rem',
    color: '#8B5E3C',
    fontFamily: '"Lora", serif',
    marginBottom: '10px',
  },
  productPrice: {
    fontSize: '1.4rem',
    color: '#F4C430',
    fontWeight: 'bold',
    fontFamily: '"Playfair Display", serif',
    marginBottom: '12px',
  },
  addButton: {
    padding: '12px 24px',
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  cartButton: {
    padding: '12px 24px',
    backgroundColor: '#F4C430',
    color: '#3C2F2F',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    margin: '5px',
    fontFamily: '"Lora", serif',
  },
 cartButtonM: {
    padding: '12px 24px',
    backgroundColor: '#F4C430',
    color: '#3C2F2F',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    margin: '5px',
    fontFamily: '"Lora", serif',
  },






  cartDetails: {
    marginTop: '25px',
    padding: '25px',
    border: '1px solid #E8D5B9',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
  },
  cartItem: {
    marginBottom: '12px',
    fontSize: '1rem',
    color: '#3C2F2F',
    fontFamily: '"Lora", serif',
  },
  submitButton: {
    padding: '12px 24px',
    backgroundColor: '#D4A373',
    color: '#FFF',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
    fontFamily: '"Lora", serif',
  },
  imageDisplay: {
    display: 'flex',
    width: '100%',
    marginTop: '20px',
    padding: '20px',
    border: '1px solid #E8D5B9',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    boxShadow: '0 4px 12px rgba(212, 163, 115, 0.15)',
    position: 'relative',
  },
  
  
  zoomArea: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #D4A373',
  },

  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    width: '30px',
    height: '30px',
    backgroundColor: '#8B5E3C',
    color: '#FFF',
    border: '1px solid #D4A373',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    fontFamily: '"Lora", serif',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    zIndex: 15,
  },
  
  
  promoPercentage: {
    margin: 0,
    padding: '0.2em 0',
  },
  discountBox: {
    backgroundColor: '#28a745', // Green background
    color: '#ffffff', // White text
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'Arial',
    display: 'inline-block',
  },
  
  
cartIconButton: {
      padding: '12px',
      backgroundColor: '#F4C430',
      color: '#3C2F2F',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '1rem',
      margin: '5px',
      fontFamily: '"Lora", serif',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    cartIcon: {
      position: 'relative',
      display: 'inline-block',
    },
    cartIconSvg: {
      width: '24px',
      height: '24px',
    },
    cartCount: {
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      backgroundColor: '#ff0000',
      color: 'white',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: 'bold',
    },

  
  

  
  
};










const PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';













const ProductImageDisplay = React.memo(function ({ productId, fetchProductImage, onProductImageClick }) {
       const [image, setImage] = useState(null);
       const [imageLoading, setImageLoading] = useState(true);
     
       useEffect(() => {
         const fetchImage = async () => {
           setImageLoading(true);
           const images = await fetchProductImage(productId, 'low-res');
           if (Array.isArray(images) && images.length > 0) {
             const img = images[0];
             const imageType = img.imageType ? img.imageType.toLowerCase() : '';
             if (['jpeg', 'jpg', 'png', 'image/jpeg', 'image/png'].includes(imageType)) {
               setImage(img);
             } else {
               setImage(null);
             }
           } else {
             setImage(null);
           }
           setImageLoading(false);
         };
     
         fetchImage();
       }, [productId, fetchProductImage]);
     
       if (imageLoading) {
         return <p style={{ ...styles.productDescription, textAlign: 'center' }}>Loading image...</p>;
       }
     
       if (!image) {
         return (
           <div style={styles.productImageWrapper}>
             <img
               src={PLACEHOLDER_IMAGE}
               alt={`Product ${productId}`}
               style={{
                 
                 height: 'auto',
                   width:'100%',
                 objectFit: 'cover',
                 borderRadius: '8px',
                 cursor: 'pointer',
               }}
               onClick={() => {
                 onProductImageClick(productId);
                 const targetDiv = document.getElementById('target-div');
                 if (targetDiv) {
                   targetDiv.scrollIntoView({
                     behavior: 'smooth',
                     block: 'start',
                   });
                 }
               }}
             />
             <p style={{ ...styles.productDescription, marginTop: '5px' }}>
               Image not available or unsupported format.
             </p>
           </div>
         );
       }
     
       const imageUrl = `data:${image.imageType.toLowerCase()};base64,${image.imageData}`;
     
       return (
         <div style={styles.productImageWrapper}>
           <img
             src={imageUrl}
             alt={`Product ${productId}`}
             style={{
               height: 'auto',
               width: '60%',
               objectFit: 'cover',
               borderRadius: '8px',
               cursor: 'pointer',
             }}
             onClick={() => {
               onProductImageClick(productId);
setSelectedProductIdd( productId );



               const targetDiv = document.getElementById('target-div');
               if (targetDiv) {
                 targetDiv.scrollIntoView({
                   behavior: 'smooth',
                   block: 'start',
                 });
               }
             }}
           />
         </div>
       );
     });



     export default ProductImageDisplay;